import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/pages/promotion/promotion-tick-badge.png")